//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CreditCardBrand } from './Enums';

export class CreditCardMetaData extends ItemBase {
    Name: string | null = null;
    NumberLength: number = 0;
    Brand: CreditCardBrand = CreditCardBrand.Amex;
    CvcLength: number = 0;

    constructor(initializer?: Partial<CreditCardMetaData>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CreditCardMetaData";
}
